import React from 'react'
import { makeStyles } from '@mui/styles'
import { useSelector } from 'react-redux'

import FloatingBadge, { Varients } from '@/modules/base/components/badge/floating-badge'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import { showLoader, hideLoader, closeTenantSelection } from '@/redux/ducks/tenant/selection'
import { switchTenant } from '@/redux/ducks/user/info'
import { AppStateType } from '@/redux/ducks'
import theme from '@/theme'
import lang from '@/lang'

import IconRedirect from '@assets/images/icons/redirect.svg'
import { useNavigate } from 'react-router'
import { useAppDispatch } from '@/redux/store'
import { SubscriptionTypeTypes } from '@/modules/base/util/constants'

const useStyles = makeStyles({
  container: {
    cursor: 'pointer',
    gap: 10,
    '&:hover': {
      color: theme.primaryBright,
    },
    '&:hover $arrow path': {
      fill: theme.primaryBright,
    },
  },

  arrow: {
    marginLeft: 6,
    fill: theme.white,
  },
})

export default function TaxConsultantUserSwitchNotch() {
  const navigate = useNavigate()
  const classes = useStyles()
  const dispatch = useAppDispatch()

  const { tenants, isOwner, isOwnerTaxConsultant } = useSelector((state: AppStateType) => state.user.info)
  if (!(isOwnerTaxConsultant && !isOwner)) return null

  // get the tax consultant tenants id
  const taxConsultantOwnerTenantId = tenants.find(tenant => tenant.subscriptions.some(subscription => subscription.type === SubscriptionTypeTypes.TaxConsultant))?.tenantId

  const switchToTaxConsultant = () => {
    dispatch(showLoader())
    dispatch(closeTenantSelection())
    dispatch(switchTenant({ tenantId: taxConsultantOwnerTenantId }, () => {
      dispatch(hideLoader())
      navigate('/')
    }))
  }

  return (
    <FloatingBadge className={classes.container} onClick={switchToTaxConsultant} varient={Varients.PRIMARY_BLUE}>
      <span>{lang.tenant.selection.backToTaxOffice}</span>
      <SVGIcon svg={IconRedirect} height={13} width={13} className={classes.arrow} />
    </FloatingBadge>
  )
}
